<template>
  <div class="carousel-cursor"
    ref="buttonCursor"
    :style="`background-image: url(${bgImg}); ${pos}; ${top};`"
  />
</template>

<script setup lang="ts">
import { onUpdated, ref } from 'vue'

const props = defineProps<{
  x: number,
  y: number,
  parent: HTMLElement,
  direction: string,
  rerender: number
}>()

const buttonCursor = ref<HTMLElement>()
const bgImg = props.direction === 'left' ? '/images/arrow-left.png' : '/images/arrow-right.png'
let pos = props.direction === 'left' ? 'left: 0' : 'right: 0'
let top = 'top: 0'

onUpdated(() => {
  updateCursor()
})

const updateCursor = () => {
  const rect = props.parent.getBoundingClientRect()
  const show = rect.left < props.x && props.parent.getBoundingClientRect().right > props.x && props.y > rect.top && props.y < rect.bottom
  buttonCursor.value?.classList.toggle('carousel-cursor--visible', show)
  pos = props.direction === 'left' ? `left: ${props.x - rect.left}px` : `right: ${rect.right - props.x}px`
  top = `top: ${props.y - rect.top}px`
}

</script>

<style scoped lang="postcss">
.carousel-cursor {
  position: absolute;
  display: none;
  width: 12rem;
  height: 4rem;
  background-size: 192px 64px;

  &--visible {
    display: block;
  }
}
</style>
